module.exports = __webpack_public_path__ + "static/media/logo_trondelag_white.172e82fc.png";